<template>
  <a-drawer width="70%" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>统一订单详情</b>
    </a-divider>
    <a-empty description="详情内容待补充">
      <template v-if="orderId">
        订单编号：{{ orderId }}
      </template>
    </a-empty>
  </a-drawer>
</template>

<script>
// 占位组件：仅保证编译通过，具体详情内容后续补充。
// 对外暴露 handleDetail(id) 方法并派发 ok 事件，与调用方保持一致。
export default {
  name: 'UniformDetailForm',
  data () {
    return {
      open: false,
      orderId: undefined
    }
  },
  methods: {
    handleDetail (id) {
      this.orderId = id
      this.open = true
    },
    onClose () {
      this.open = false
      this.orderId = undefined
      this.$emit('ok')
    }
  }
}
</script>
